const createMainBranch = mainAddress => {
  return {
    value: {
      hq: true,
      street: mainAddress.street,
      city: mainAddress.city,
      zip: mainAddress.zip,
      label: `${mainAddress.street}, ${mainAddress.zip} ${mainAddress.city}`,
    },
    label: `${mainAddress.street}, ${mainAddress.zip} ${mainAddress.city}`,
  };
};

export default createMainBranch;
